module.exports = __webpack_public_path__ + "static/img/14.913a12aa.png";